var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.67333e-05H6.18C4 0 7.7 8.53027e-05 9 8.53027e-05C10.3 8.53027e-05 13.91 8.67333e-05 11.82 8.67333e-05H16C17.1 8.67333e-05 18 0.900087 18 2.00009V16.0001C18 17.1001 17.1 18.0001 16 18.0001H2C0.9 18.0001 0 17.1001 0 16.0001V2.00009C0 0.900087 0.9 8.67333e-05 2 8.67333e-05ZM5 12.0001H9V15.0001L14 10.0001L9 5.00009V8.00009H5V12.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.d100f8ff16a9cf3f71b0ff8809fea680.svg";
export { ForwardRef as ReactComponent };